import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing a view for filtering concepts.
 * @extends JetView
 */
export default class FilterConceptsView extends JetView {
    /**
     * Configures the layout of the filter concepts view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing input fields for filtering
        const left = {
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Input for ID
                            name: 'Id',
                            type: 'number',
                            minWidth: 200,
                            label: _("<span class='icon-drivers-license-o'></span>ID"),
                            labelPosition: 'top',
                            placeholder: _('ID'),
                        },
                        {
                            view: 'richselect', // Dropdown for Type selection
                            name: 'Type',
                            minWidth: 200,
                            label: _('Tipo'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'E', value: _('Egresos') },
                                { id: 'I', value: _('Ingresos') },
                            ],
                        },
                        {
                            view: 'text', // Input for Name
                            name: 'Name',
                            minWidth: 200,
                            label: "<span class='icon-user'></span>" + _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                        },
                        {
                            view: 'combo', // Combo box for Chart Accounts
                            name: 'ChartAccounts',
                            id: 'ChartAccounts',
                            minWidth: 200,
                            label: _('ID Plan de Cuentas'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'text', // Input for Reference
                            name: 'Reference',
                            minWidth: 200,
                            label: "<span class='icon-price-tag'></span>" + _('Referencia'),
                            labelPosition: 'top',
                            placeholder: _('Referencia'),
                        },
                    ],
                },
            ],
        };

        // Center right section (currently empty)
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section containing the left section
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Button section with actions for adding, clearing, and consulting
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        {
                            view: 'button', // Button to add a concept
                            value: _('Añadir Concepto'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            hidden: !devConfig.getPermAction('accountingConceptsAdd', 'Add'), // Permission check
                            css: 'prm-accountingConceptsAdd',
                            click: () => {
                                this.app.callEvent('addConcepts:button', [{}]); // Event to add concept
                            },
                        },
                        {
                            view: 'button', // Button to clear the form
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            click: () => {
                                this.getRoot().clear(); // Clear form values
                            },
                        },
                        {
                            view: 'button', // Button to consult concepts
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter values
                                this.app.callEvent('concepts:filter', [filterdata]); // Event to filter concepts
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section for mobile and desktop views
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            view: 'button', // Button to consult concepts in mobile view
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            id: 'consultMobile',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter values
                                this.app.callEvent('concepts:filter', [filterdata]); // Event to filter concepts
                            },
                        },
                        {
                            header: _('Filtros'), // Header for filters section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Main form configuration
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [accordion_section],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     */
    init() {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('consultDesk').hide(); // Hide desktop consult button on small screens
            }
            if (screen.width >= 500) {
                $$('consultMobile').hide(); // Hide mobile consult button on larger screens
            }
        });

        // AJAX request to fetch chart accounts options
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(
                devConfig.geturlApi() + 'Accounting/GetChartAccountsSelect', // API endpoint
                '',
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(_('Error! ')); // Show error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse response
                        $$('ChartAccounts').define('options', resp.Data); // Define options for ChartAccounts
                        $$('ChartAccounts').refresh(); // Refresh the combo box
                    },
                },
            );
    }
}

// FILE DOCUMENTED
